import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route only. Head metadata and JSON-LD live on the leaf routes
// (/portfolio-rental-loans/ index, /$state, /$state/$city) so child pages don't inherit
// the product hub's FAQPage, Article, and BreadcrumbList schema.
export const Route = createFileRoute("/portfolio-rental-loans")({
  component: () => <Outlet />,
});
